import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileComponent } from '../../profile/profile.component';
import { AppRoutingModule } from '../../app-routing.module';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { MyaccountComponent } from './myaccount.component';
import { ChangePasswordComponent } from '../../change-password/change-password.component';

@NgModule({
  declarations: [
    MyaccountComponent,
    ProfileComponent,
    ChangePasswordComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ]
})
export class MyaccountModule { }
